import { customMedia } from '@space-core/styles'
import type { ThemeMode } from '@space-core/styles/themes/enum'
import { ShowcaseOrientation } from '@space-shell/common/services/membership'
import styled from 'styled-components'

import { Avatar } from './thumbnail'

export const CTAContainer = styled.div`
  gap: 1rem;

  ${customMedia.between('md', 'xl')`
      display: block !important;
    `}
`

export const Info = styled.div<{ $theme?: ThemeMode }>`
  display: block;
  z-index: 2;
  bottom: 0;
  transform: translateY(100%);
  transition: transform calc(var(--timing) / 2) var(--easing);
  background-color: var(--bg-primary);
`

export const Container = styled.div`
  display: block;
  transition: all 0.3s ease;
  opacity: 1;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  transition: opacity var(--timing) var(--easing) calc(var(--timing) / 2),
    top var(--timing) var(--easing), right var(--timing) var(--easing),
    bottom var(--timing) var(--easing), left var(--timing) var(--easing),
    box-shadow var(--timing) var(--easing);
`

export const Footer = styled.div`
  opacity: 1;
  transition: all 0.3s ease;
`

export const Wrapper = styled.div<{ $orientation?: ShowcaseOrientation }>`
  display: block;
  outline: none;
  aspect-ratio: ${({ $orientation }) =>
    $orientation === ShowcaseOrientation.HORIZONTAL ? '16/9' : '9/13'};

  @supports not (aspect-ratio: 9/13) {
    &:before {
      content: '';
      float: left;
      padding-top: 144.44%;
    }

    &:after {
      clear: both;
      content: '';
      display: block;
    }
  }

  @supports not (aspect-ratio: 16/9) {
    &:before {
      float: left;
      padding-top: 56.25%;
      content: '';
    }

    &:after {
      display: block;
      content: '';
      clear: both;
    }
  }

  &:is(:focus, :hover) ${Container} {
    ${({ $orientation }) => customMedia.greaterThan('md')`
        z-index: 4;
        opacity: 1;
        transform: translateY(0);
        box-shadow: 0rem 0rem 0rem 0.25rem var(--gray-900);
        transition: all var(--timing) var(--easing) calc(var(--timing) / 3);
        left: -1.7rem;
        right: -1.7rem;
        bottom: ${$orientation === ShowcaseOrientation.HORIZONTAL ? `-6rem;` : `-1.7rem;`}
        top: ${$orientation === ShowcaseOrientation.HORIZONTAL ? `-6rem;` : `-1.7rem;`}
    `};
  }

  &:is(:focus, :hover) ${Info} {
    ${customMedia.greaterThan('md')`
      transform: translateY(0);
      transition: transform 0.8s var(--easing) calc(var(--timing) / 2);
    `}
  }

  &:is(:focus, :hover) ${Avatar} {
    ${({ $orientation }) => customMedia.greaterThan('md')`
    height: ${$orientation === ShowcaseOrientation.HORIZONTAL ? `100%` : `65%`};
    width: ${$orientation === ShowcaseOrientation.HORIZONTAL ? `70%` : `100%`};
    transition: all 0.8s var(--easing) calc(var(--timing) / 2), width 0.4s var(--easing);
  `}
  }

  &:is(:focus, :hover) ${Footer} {
    ${customMedia.greaterThan('md')`
      opacity: 0;
      visibility: hidden;
    `}
  }
`

export const ProductStatus = styled.div`
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border: solid 0.063rem var(--gray-100);
  border-radius: 0.25rem;
  width: max-content;
  z-index: 20;
`
